import { Button } from '@yellowcard/components-library-vue3';
import { defineComponent } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { storeToRefs } from 'pinia';
import { KycTypes } from '@/types/kyc';
export default defineComponent({
    name: 'IDDetails1',
    props: {},
    components: {
        Button,
    },
    setup() {
        const kycStore = useKycStore();
        const { currentStep, requireDoubleIdNG } = storeToRefs(kycStore);
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const backClick = () => {
            currentStep.value = KycTypes.KycSteps.KYC_4;
        };
        const proceed = () => {
            if (requireDoubleIdNG.value) {
                // no id selection, require both nin + bvn
                currentStep.value = KycTypes.KycSteps.KYC_7;
            }
            else {
                currentStep.value = KycTypes.KycSteps.KYC_6;
            }
        };
        return {
            backClick,
            proceed,
            onKeyPress,
        };
    },
});
